jQuery(document).ready(function() {
	jQuery("#dropdown-mobilenav").on("show.zf.dropdown", function(e) {
		jQuery('body').addClass('disable-scroll');
	});
	jQuery("#dropdown-mobilenav").on("hide.zf.dropdown", function(e) {
		jQuery('body').removeClass('disable-scroll');
	});
	jQuery('.new-back').each(function(){
		var parent = jQuery(this).parent().closest('.is-drilldown-submenu-parent');
		if(parent.find('> ul').hasClass('menu-depth-1')) {
			var backTxt = 'MAIN MENU';
		} else {
			var backTxt = parent.siblings('li[data-is-parent-link]').find(' > a').text();
	
		}
		jQuery(this).text(backTxt);
	});
});
const appHeight = () => {
	const doc = document.documentElement
	doc.style.setProperty('--app-height', `${window.innerHeight - 74}px`)
}
window.addEventListener('resize', appHeight)
appHeight()


